export class NameDisplayValString {
  public Name: string;
  public Display: string;
  public Value: string;

  public constructor(itemName?: string, itemDisplay?: string, itemValue?: string) {
    if (itemName == null || itemName == undefined) {
      this.Name = '';
    } else {
      this.Name = itemName;
    }
    if (itemDisplay == null || itemDisplay == undefined) {
      this.Display = '';
    } else {
      this.Display = itemName;
    }

    if (itemValue == null || itemValue == undefined) {
      this.Value = null;
    } else {
      this.Value = itemValue;
    }
  }
}
